import { useState, useEffect, useRef } from "react";
import "./FlappyBird.css";

export default function FlappyBird() {
  const [birdPosition, setBirdPosition] = useState(250); // Y position
  const [gameStarted, setGameStarted] = useState(false);
  const [obstacles, setObstacles] = useState([]);
  const [score, setScore] = useState(0);
  const gravity = 4;
  const jumpHeight = 60;
  const obstacleWidth = 60;
  const gap = 150;
  const gameAreaHeight = 500;
  const gameAreaWidth = 400;

  const gameLoopRef = useRef(null);

  // Generate random height for obstacle
  const randomHeight = () => Math.floor(Math.random() * 200) + 100;

  // Start or restart the game
  const startGame = () => {
    setGameStarted(true);
    setObstacles([{ x: gameAreaWidth, height: randomHeight() }]);
    setBirdPosition(gameAreaHeight / 2);
    setScore(0);
  };

  // Bird jump
  const jump = () => {
    if (!gameStarted) return startGame();
    setBirdPosition((prev) => Math.max(prev - jumpHeight, 0));
  };

  // Game loop
  useEffect(() => {
    if (!gameStarted) return;

    gameLoopRef.current = setInterval(() => {
      // Gravity effect
      setBirdPosition((prev) => Math.min(prev + gravity, gameAreaHeight - 30)); // bird height 30

      // Move obstacles
      setObstacles((prev) =>
        prev
          .map((obs) => ({ ...obs, x: obs.x - 5 }))
          .filter((obs) => obs.x + obstacleWidth > 0)
      );

      // Add new obstacles
      if (obstacles.length === 0 || obstacles[obstacles.length - 1].x < gameAreaWidth - 200) {
        setObstacles((prev) => [...prev, { x: gameAreaWidth, height: randomHeight() }]);
      }

      // Collision detection
      obstacles.forEach((obs) => {
        const birdLeft = 50;
        const birdRight = birdLeft + 30;
        const birdTop = birdPosition;
        const birdBottom = birdTop + 30;

        const obsLeft = obs.x;
        const obsRight = obs.x + obstacleWidth;
        const obsTopBottom = obs.height + gap;

        if (
          birdRight > obsLeft &&
          birdLeft < obsRight &&
          (birdTop < obs.height || birdBottom > obsTopBottom)
        ) {
          setGameStarted(false); // Game Over
        }
      });

      // Update score
      obstacles.forEach((obs) => {
        if (obs.x + obstacleWidth === 50) {
          setScore((prev) => prev + 1);
        }
      });
    }, 30);

    return () => clearInterval(gameLoopRef.current);
  }, [gameStarted, birdPosition, obstacles]);

  return (
    <div className="flappy-container" onClick={jump}>
      <h2>Flappy Bird Clone</h2>
      <p>Score: {score}</p>
      {!gameStarted && <p className="start-msg">Click or tap to start!</p>}

      <div className="game-area" style={{ height: gameAreaHeight, width: gameAreaWidth }}>
        {/* Bird */}
        <div className="bird" style={{ top: birdPosition }}></div>

        {/* Obstacles */}
        {obstacles.map((obs, index) => (
          <div key={index}>
            <div className="obstacle top" style={{ left: obs.x, height: obs.height }}></div>
            <div className="obstacle bottom" style={{ left: obs.x, top: obs.height + gap }}></div>
          </div>
        ))}
      </div>

      {!gameStarted && score > 0 && (
        <p className="game-over">💥 Game Over! Your Score: {score}</p>
      )}
    </div>
  );
}
